import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as uiActions from '~actions/ui-actions';

import * as accountsAPI from '~api/accounts';

import IdentityProviderDetailsAccountList from '~components/identity-providers/identity-provider-details-account-list';
import IdentityProviderDetailsMetadata from '~components/identity-providers/identity-provider-details-metadata';
import IdentityProviderDetailsProperties from '~components/identity-providers/identity-provider-details-properties';
import { IdentityProvider } from '~components/identity-providers/identity-provider-prop-types';

export default function IdentityProviderDetails({ identityProvider, onUpdate }) {
  const [ linkedAccounts, setLinkedAccounts ] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await accountsAPI.searchAccountsPage(`lucid-auth:idps:${identityProvider.id}`, 0, 50, true);
        setLinkedAccounts(data.accounts);
      } catch (error) {
        dispatch(uiActions.setErrorMessage(error));
      }
    })();
  }, [ dispatch, identityProvider.id ]);

  return (
    <div className="splitColumns withMobileMargins">
      <div className="column100">
        <IdentityProviderDetailsProperties
          linkedAccounts={linkedAccounts}
          identityProvider={identityProvider}
          onUpdate={onUpdate}
        />
        <IdentityProviderDetailsMetadata identityProvider={identityProvider} onUpdate={onUpdate} />
        <IdentityProviderDetailsAccountList linkedAccounts={linkedAccounts} />
      </div>
    </div>
  );
}

IdentityProviderDetails.propTypes = {
  identityProvider: IdentityProvider.isRequired,
  onUpdate: PropTypes.func.isRequired
};
